<template>
  <div class="condition-wrap">
    <p>
      <span>筛选条件</span>
      <span class="reset-btn pointer" @click="reset">重新筛选</span>
    </p>
    <el-form class="condition-form">
      <el-form-item>
        <div style="display: flex">
          <el-checkbox style="margin-right: 30px" v-model="talentAll" @change="handleCheckAllChange($event, 1)">人才层次:</el-checkbox>
          <el-checkbox-group v-model="talentCheck" @change="handleCheckedCitiesChange($event, 1)">
            <el-checkbox v-for="item in talentList" :key="item" :label="item" />
          </el-checkbox-group>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="display: flex">
          <el-checkbox style="margin-right: 30px" v-model="degreeAll" @change="handleCheckAllChange($event, 2)">人才学历:</el-checkbox>
          <el-checkbox-group v-model="degreeCheck" @change="handleCheckedCitiesChange($event, 2)">
            <el-checkbox v-for="item in degreeList" :key="item" :label="item" />
          </el-checkbox-group>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="display: flex">
          <el-checkbox style="margin-right: 30px" v-model="policyAll" @change="handleCheckAllChange($event, 3)">政策类型:</el-checkbox>
          <el-checkbox-group v-model="policyCheck" @change="handleCheckedCitiesChange($event, 3)">
            <el-checkbox v-for="item in policyList" :key="item" :label="item" />
          </el-checkbox-group>
        </div>
      </el-form-item>
      <!-- <el-form-item>
        <el-button icon="el-icon-search" type="primary">搜索</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import bus from '@/bus.js'
export default {
  name: 'SelectCondition',
  data() {
    return {
      talentList: ['顶尖人才', '特优人才', '领军人才', '拔尖人才', '高级人才', '基础人才'],
      talentAll: false,
      talentCheck: [],
      degreeList: ['博士', '硕士', '本科', '专科', '其他'],
      degreeAll: false,
      degreeCheck: [],
      policyList: ['生活安居类', '培养升级类', '引才支持类', '科创支持类', '暖心服务类', '其他'],
      policyAll: false,
      policyCheck: [],
    }
  },
  methods: {
    handleCheckAllChange(val, id) {
      switch (id) {
        case 1:
          this.talentCheck = val ? this.talentList : []
          break
        case 2:
          this.degreeCheck = val ? this.degreeList : []
          break
        case 3:
          this.policyCheck = val ? this.policyList : []
          break
        default:
          break
      }
      bus.$emit('accept', this.talentCheck, this.degreeCheck, this.policyCheck)
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value, id) {
      let checkedCount = value.length
      switch (id) {
        case 1:
          this.talentAll = checkedCount == this.talentList.length
          break
        case 2:
          this.degreeAll = checkedCount == this.degreeList.length
          break
        case 3:
          this.policyAll = checkedCount == this.policyList.length
          break
        default:
          break
      }
      bus.$emit('accept', this.talentCheck, this.degreeCheck, this.policyCheck)
    },
    reset() {
      this.talentCheck = []
      this.talentAll = false
      this.degreeCheck = []
      this.degreeAll = false
      this.policyCheck = []
      this.policyAll = false
      bus.$emit('accept', this.talentCheck, this.degreeCheck, this.policyCheck)
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
